import * as React from 'react';
import {View, StyleSheet, Linking} from 'react-native';
import {withForwardedNavigationParams} from 'react-navigation-props-mapper';
import ScreenContext from '../ScreenContext';
import ScanditView from '../elements/ScanditView';
import NavActions from 'src/actions/NavActions';
import BaseScreen from './BaseScreen';
import Styles from '../Styles';
import AVText from '../elements/AVText';
import Localized from 'src/constants/AppStrings';
import {alertError} from '../helpers/AlertHelper';
type ConnectScreenProps = Record<string, unknown>;
type ConnectScreenState = {
  scanning: boolean;
};

class ConnectScreen extends React.Component<
  ConnectScreenProps,
  ConnectScreenState
> {
  didFocusListener: any;
  willBlurListener: any;
  static contextType = ScreenContext;

  constructor(props: ConnectScreenProps) {
    super(props);
    this.state = {
      scanning: true,
    };
    this.qrCodeScanned = this.qrCodeScanned.bind(this);
  }

  async qrCodeScanned(url: string) {
    this.setState({
      scanning: false,
    });
    const canOpen = await Linking.canOpenURL(url);

    if (canOpen) {
      Linking.openURL(url);
      NavActions.pop();
    } else {
      alertError(
        Localized.Errors.unable_to_read_code_please_try_again,
        null,
        () => {
          this.setState({
            scanning: true,
          });
        },
      );
    }
  }

  render() {
    return (
      <BaseScreen title={Localized.Labels.connect}>
        <View style={styles.content}>
          <AVText style={styles.label}>
            {Localized.Labels.scan_qr_canteen_connect}
          </AVText>
          <ScanditView
            style={styles.scanditContainer}
            barcodeScanned={this.qrCodeScanned}
            scanning={this.state.scanning}
          />
        </View>
      </BaseScreen>
    );
  }
}

const styles = StyleSheet.create({
  content: {
    flex: 1,
    paddingTop: 15,
  },
  label: {
    color: Styles.darkColor,
    fontSize: Styles.Fonts.f3,
    textAlign: 'center',
  },
  scanditContainer: {
    flex: 1,
    marginTop: 32,
  },
});
export default withForwardedNavigationParams()(ConnectScreen);
